// extracted by mini-css-extract-plugin
export default {"loader":"spinner_loader__l+nIi","jimu_primary_loading":"spinner_jimu_primary_loading__VDJIm","loading-keys-app-loading":"spinner_loading-keys-app-loading__4vS9q"};